import en from './en.json';
import pl from './pl.json';

export const localeResources = {
  en: { translation: en },
  pl: { translation: pl },
} as const;
